import FormOptionCard, {
  FormOptionCardConfig,
} from "app/components/FormOptionCard";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch } from "react-redux";

import {
  standardKey,
  standardLabels,
  useQuoteAccessories,
} from "../../../hooks/useQuoteAccessories";
import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { quotesActions } from "../../../redux/slice";
import { QuoteStandardCard } from "../../../types";
import { CardRow } from "./BoxStructureFields";
import { NumberedSectionTitle } from "./FormFields";
import { useStyles } from "../styles";

const noteField = (titleKey: string): FormOptionCardConfig => ({
  titleKey,
  fields: ["note"],
  notePlaceholderKey: standardKey("FIELDS.NOTE"),
});

const standardCards: Record<QuoteStandardCard, FormOptionCardConfig> = {
  sideGuardsReflectors: {
    titleKey: standardKey("CARDS.SIDE_GUARDS_REFLECTORS"),
    fields: ["radio", "note"],
    radioLabelKey: standardKey("FIELDS.TYPE"),
    notePlaceholderKey: standardKey("FIELDS.NOTE"),
    radioOptions: [
      { value: "ALUMINUM", labelKey: standardKey("OPTIONS.ALUMINUM") },
      { value: "IRON", labelKey: standardKey("OPTIONS.IRON") },
    ],
  },
  sideLighting: noteField(standardKey("CARDS.SIDE_LIGHTING")),
  standardMudguards: noteField(standardKey("CARDS.STANDARD_MUDGUARDS")),
};

const Standard = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useQuoteAccessories();

  const renderCard = (cardId: QuoteStandardCard) => (
    <FormOptionCard
      key={cardId}
      config={standardCards[cardId]}
      value={data.standard[cardId]}
      labels={standardLabels}
      onChange={(value) =>
        dispatch(
          quotesActions.updateAccessories({
            section: "standard",
            key: cardId,
            value,
          })
        )
      }
    />
  );

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={5}
        titleKey={formKey("SECTIONS.STANDARD")}
      />
      <CardRow columns={3}>
        {renderCard("sideGuardsReflectors")}
        {renderCard("sideLighting")}
        {renderCard("standardMudguards")}
      </CardRow>
    </Box>
  );
};

export default Standard;
